import { ButtonHook } from 'common/Prose/Toolbar/Types'
import { timedOutToggleMark } from 'common/Prose/Toolbar/utils/util'
import { computed } from 'mobx'
import { schema } from 'prose-core'
import { EditorView } from 'prosemirror-view'
import { useContext } from 'react'
import { AlmanacEditorStateContext } from 'stores/EditorState'

export function useStrikethroughToggle(view: EditorView): ButtonHook<any> {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const almanacState = useContext(AlmanacEditorStateContext)!

  const hasStrikethrough = computed(() => almanacState.activeMarks.has(schema.marks.strike)).get()

  const hasCodeBlock = computed(() => almanacState.activeNodes.has(schema.nodes.code_block)).get()

  return {
    active: hasStrikethrough,
    handleClick: timedOutToggleMark(schema.marks.strike, view),
    disabled: hasCodeBlock,
  }
}
